import Button from '../../components/common/button';

const SchoolForm = (props) => {
  const {
    submitLabel,
    submitAction,
    children,
    disabled
  } = props;

  return (
    <form className='add-school-form'>
      <div className='form-body'>
        <div className='form-items'>
          { children }
          <div className='form-buttons'>
            <Button label={submitLabel} action={submitAction} disabled={disabled}/>
          </div>
        </div>
      </div>
    </form>
  );
};

export default SchoolForm;
